export default __webpack_public_path__ + "static/media/icon-due.40b24413.svg";